import store from 'store'
import moment from 'moment'

const serverDateFormat = 'yyyy-MM-DD'

export function now () {
  return moment().format(serverDateFormat)
}

export function localeNow () {
  return moment().format(store.state.i18n.date_format)
}

export function toLocaleDate (date, currentFormat = serverDateFormat, outputFormat = store.state.i18n.date_format) {
  return moment(date, currentFormat).format(outputFormat)
}

export function toServerDate (date, currentFormat = store.state.i18n.date_format, outputFormat = serverDateFormat) {
  return moment(date, currentFormat).format(outputFormat)
}
